import { Box, Button, Link } from "@mui/material";
import { useTheme } from "@mui/styles";
import React from "react";
import { getEnvironmentVariable } from "../global/environmentVariables";
import { findGetParameter } from "../utils/urlParams";
import { isAppMode } from "../utils/GeneralUtils";
import { BCPArrowLeftToLine } from "../utils/icons/BCPIcon";
const SYSTEM_IMAGES_CLOUDFRONT = getEnvironmentVariable(
  "SYSTEM_IMAGES_CLOUDFRONT"
);

export default function MainHeader(props) {
  const theme = useTheme();
  let redirect_uri = findGetParameter("redirect_uri");
  const appMode = isAppMode();

  return (
    <>
      {!appMode && (
        <Button
          onClick={() => {
            if (redirect_uri && redirect_uri !== "") {
              if (redirect_uri.endsWith("/login"))
                redirect_uri = redirect_uri.slice(0, -"/login".length);

              window.location.assign(redirect_uri);
            } else {
              window.history.back();
            }
          }}
          startIcon={
            <BCPArrowLeftToLine
              sx={{
                fontSize: "16px",
                fontWeight: "16px",
                color: theme.palette.link.main,
              }}
            />
          }
          sx={{ mb: -4, color: theme.palette.link.main }}
        >
          Go back
        </Button>
      )}

      <Box
        sx={{
          flexGrow: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          mb: -4,
        }}
      >
        <Link
          href={!appMode ? getEnvironmentVariable("HOME_PAGE") : null}
          underline="none"
        >
          <img
            src={`${SYSTEM_IMAGES_CLOUDFRONT}/images/BannerLogo${
              theme.palette.mode === "dark" ? "Dark" : ""
            }.png`}
            alt="logo"
            style={{
              maxHeight: "80px",
            }}
          />
        </Link>
      </Box>
    </>
  );
}
